import { createSingleAction } from 'store/utils';

const SET_EDIT_ENTRY_ID = 'time_and_expense/SET_EDIT_ENTRY_ID';
export const setEditEntryId = createSingleAction<string | null, typeof SET_EDIT_ENTRY_ID>(SET_EDIT_ENTRY_ID);
